


































































import {Component, PropSync, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {DatePickerWings, FastDateDetailWings, FilterWings, SelectWings, FilterSelectedItemWings} from "wings-ui-components";
import {ReportFilter} from "@/store/reports/types";
import {beginningOfCurrentDay, currentDateEnd} from "@/utils/date-util";
import {DateTime} from "luxon";
import {notifyError, notifyWarning} from '@/utils/notify-helper';
import { getTranslatedParams } from "@/utils/notify-utils";

@Component({
  components: {
    DatePickerWings,
    FastDateDetailWings,
    FilterSelectedItemWings,
    FilterWings,
    SelectWings,
  },
  filters: {
    date(value: string) {
      return DateTime.fromISO(value).toFormat('dd.LL.yyyy HH:mm')
    }
  }
})
export default class ReportsFilter extends BaseFilter<ReportFilter> {
  @PropSync('show') is_show!: boolean;
  @PropSync('runFilter') propRunFilter!: boolean;
  @Getter("reportStatusList") statusList: any;
  @Getter("reportTypeList") typesList: any;
  @Action("getReports") actionGetReports: any;
  @Action("actionLog") actionLog: any;

  defaultFilter():ReportFilter {
    return {
      date_from: beginningOfCurrentDay(),
      date_to: currentDateEnd(),
      status: undefined,
    }
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Report",
        addititionalInfo: getTranslatedParams(this.filter)
      }
      const resp = await this.actionGetReports(this.filter);
      await this.actionLog(this.logObject)
      if (resp.status === 204) {
        notifyWarning()
      }
    } catch(err) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(err)
    }
  }

  @Watch('runFilter')
  onRunFilterChange(val: boolean) {
    if (!val) return;
    this.filtered();
    this.propRunFilter = false;
  }
}
